import * as _uuid2 from "uuid";
var _uuid = _uuid2;
try {
  if ("default" in _uuid2) _uuid = _uuid2.default;
} catch (e) {}
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UuidGenerator = void 0;
const uuid_1 = _uuid;
class UuidGenerator {
  // #endregion Properties (1)
  // #region Public Static Accessors (1)
  static get instance() {
    return this._instance || (this._instance = new this());
  }
  // #endregion Public Static Accessors (1)
  // #region Public Methods (4)
  /**
   * Creates a new uuid v4.
   */
  create() {
    return (0, uuid_1.v4)();
  }
  /**
   * Parse the uuid to array of bytes
   *
   * @param uuid the uuid to convert
   * @returns ArrayLike collection of 16 values
   */
  parse(uuid) {
    return (0, uuid_1.parse)(uuid);
  }
  /**
   * Stringify an array of bytes to an uuid
   *
   * @param uuid the array of bytes
   * @returns the converted uuid
   */
  stringify(uuid) {
    return (0, uuid_1.stringify)(uuid);
  }
  /**
   * Checks if the provided string is a valid uuid.
   *
   * @param uuid the uuid to check
   */
  validate(uuid) {
    return (0, uuid_1.validate)(uuid);
  }
}
exports.UuidGenerator = UuidGenerator;
//# sourceMappingURL=UuidGenerator.js.map
export default exports;